import { ServiceOrder } from '@turizi/shared';
import { ServiceOrderInventoryRows } from './service-order-inventory-selection';
import ServiceBookingInServiceOrder from '../service-booking-in-service-order';

interface ServiceOrderSummaryDetailProps {
    order: ServiceOrder;
    readOnly?: boolean;
}

export default function ServiceOrderSummaryDetail({
    order,
    readOnly = false
}: ServiceOrderSummaryDetailProps): JSX.Element {
    const directBookings = (order?.service_bookings || []).filter(Boolean);
    const hasResources = (order?.service_order_inventory_items?.length || 0) > 0 || (directBookings?.length || 0) > 0;

    return (
        <div>
            {hasResources ? (
                <div className="subtle-table-sm">
                    <table>
                        <tbody className="divide-y divide-gray-100 bg-white">
                            <ServiceOrderInventoryRows
                                order={order}
                                readOnly={readOnly}
                            />
                            {directBookings?.map(booking => (
                                <ServiceBookingInServiceOrder
                                    key={booking.id}
                                    booking={booking}
                                    readOnly={readOnly}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="solid-box-border text-sm italic text-gray-300">
                    -
                </div>
            )}
            {order.observations && (
                <div className="text-xs solid-box-border-negative mt-2">
                    {order.observations}
                </div>
            )}
        </div>
    );
}
